import { render, staticRenderFns } from "./CalendarEventPopover.vue?vue&type=template&id=2321904d&scoped=true"
import script from "./CalendarEventPopover.vue?vue&type=script&lang=js"
export * from "./CalendarEventPopover.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventPopover.vue?vue&type=style&index=0&id=2321904d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2321904d",
  null
  
)

export default component.exports